module.exports = __webpack_public_path__ + "media/home/employee-clipboard-d89ac01b.jpg";